/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Bill = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3 1H21V23L18 21L15 23L12 21L9 23L6 21L3 23V1ZM4.5 2.5V20.1972L6 19.1972L9 21.1972L12 19.1972L15 21.1972L18 19.1972L19.5 20.1972V2.5H4.5Z"
                        fill={color}
                    />
                    <path
                        d="M11.406 16.75H12.75V15.55C14.358 15.37 15.366 14.422 15.366 13.042C15.366 11.374 14.334 10.798 13.122 10.45L11.706 10.054C11.118 9.886 10.734 9.634 10.734 9.106C10.734 8.506 11.238 8.158 12.09 8.158C13.014 8.158 13.59 8.686 13.698 9.322H15.282C15.186 7.942 14.214 7.006 12.75 6.79V5.686H11.406V6.79C10.026 7.018 9.09 7.918 9.09 9.118C9.09 10.642 10.086 11.254 11.274 11.59L12.69 11.986C13.29 12.154 13.734 12.49 13.734 13.078C13.734 13.738 13.098 14.182 12.174 14.182C11.19 14.182 10.41 13.486 10.338 12.574H8.754C8.85 14.158 9.894 15.25 11.406 15.514V16.75Z"
                        fill={color}
                    />
                </svg>
        );
    };
